import { Grid, Typography, useMediaQuery, useTheme } from '@mui/material'

import classes from '../../index.styles'

import BatteryIndicatorItem from './battery-indicator-item'
import DefrouteItem from './defroute-item'
import LeakItem from './leak-item'
import Nh3Item from './nh3-item'
import Nh3WarningItem from './nh3-warning-item'
import NumberItem from './number-item'
import PowersourceItem from './powersource-item'
import SignalIndicatorItem from './signal-indicator-item'
import ValvePositionItem from './valve-position-item'

const StatusSectionItem = ({
  label,
  channel,
  channelName,
  nodeTypeName,
  isWrapping,
  activeAlerts,
}: {
  label: string
  channel: IChannelValueType
  channelName: string
  nodeTypeName: string
  isWrapping: boolean
  activeAlerts: IAlertHistory[]
}) => {
  const theme = useTheme()
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'))
  const channelValue = channel?.value as string | number | null
  const isAlerting = activeAlerts.some((alert) => alert.channel === channelName)

  return (
    <Grid container={true} sx={classes.statusItem(theme, isLargeScreen, isWrapping ?? false)}>
      <Typography variant="overline">{label}</Typography>
      {channelName === 'temp' && <NumberItem value={channelValue as string} isAlerting={isAlerting} />}
      {channelName === 'leak' && <LeakItem value={channelValue as number} />}
      {channelName === 'leak_probe' && <LeakItem value={channelValue as number} />}
      {channelName === 'signal_indicator' && <SignalIndicatorItem value={channelValue as number} nodeTypeName={nodeTypeName} />}
      {channelName === 'battery_indicator' && <BatteryIndicatorItem value={channelValue as number} />}
      {channelName === 'probe_temp' && <NumberItem value={channelValue as string} isAlerting={isAlerting} />}
      {channelName === 'hum' && <NumberItem value={channelValue as string} isAlerting={isAlerting} />}
      {channelName === 'water_pressure' && <NumberItem value={channelValue as string} isAlerting={isAlerting} />}
      {channelName === 'nh3' && <Nh3Item value={channelValue as number} isAlerting={isAlerting} />}
      {channelName === 'warning_nh3' && <Nh3WarningItem value={channelValue as number} isAlerting={isAlerting} />}
      {channelName === 'powersource' && <PowersourceItem value={channelValue as string} />}
      {channelName === 'defroute' && <DefrouteItem />}
      {channelName === 'valve' && <ValvePositionItem value={channelValue as string} />}
    </Grid>
  )
}

export default StatusSectionItem
